import { render, staticRenderFns } from "./RacingOddsComparisonTable.vue?vue&type=template&id=29ed67bc"
import script from "./RacingOddsComparisonTable.vue?vue&type=script&lang=js"
export * from "./RacingOddsComparisonTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports